<template>
  <div class="container-fluid p-0">
    <div class="row m-0">
      <div class="col-md-12">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
          <ul class="list-inline custom-bullet-list ul-header">
            <li class="list-inline-item"><a class="a-header" href="/">Home</a></li>
            <li class="list-inline-item"><a class="a-header" href="#about">About</a></li>
            <li class="list-inline-item"><a class="a-header" href="#quote">Quotes</a></li>
            <li class="list-inline-item"><a class="a-header" href="#additInfo">Additional Information</a></li>
          </ul>
<!--          <div class="ms-auto">Vote August 9th</div>-->
        </nav>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body{
  margin: 0;
}
nav {
  padding: 30px;
}
.a-header {
  font-weight: bold;
  color: rgb(168, 79, 79);

  &.router-link-exact-active {
    color: rgb(168, 79, 79);
  }
}
.custom-bullet-list .list-inline-item:not(:last-child)::after {
  content: '\2022'; /* Unicode for a bullet point */

  margin: 0 0 0 8px; /* Adjust spacing as needed */
}

.ul-header{
  margin-bottom: 0;
  color: rgb(168, 79, 79);
}
</style>

<script>
// import VotedAlert from './components/VotedAlert';
// @ is an alias to /src

export default {
  name: 'App',
  components:{
    // VotedAlert,
  }
}
</script>

